<template>
  <div class="action-panel">
    <h6>Upload Bukti Transfer Kekurangan</h6>
    <p class="small text-muted">Upload bukti transfer Finance untuk menyelesaikan transaksi.</p>
    <div class="form-content-wrapper disbursement-upload-wrapper mb-0 mt-2">
      <FotoPendukung
        :fotoPendukung="buktiTransferKekuranganFoto"
        :length="1"
        :minLength="1"
        :isRemove="false"
        :isNotShowCam="true"
        gadai="true"
        @showModalPreview="openTransferKekuranganFotoPreview"
        @onChange="onUploadTransferKekurangan"
        :customClass="'hide-upload-label'"
      />
    </div>
    <b-button
      variant="pgiBtn"
      class="mt-3"
      :disabled="!buktiTransferKekuranganPublicUrl || isUploadingTransferKekurangan"
      @click="openModalConfirmTransferKekurangan"
    >
      Submit
    </b-button>

    <b-modal id="modal-preview-foto-transfer-kekurangan" size="lg" title="Foto Bukti Transfer Kekurangan" ok-only ok-title="Tutup">
      <b-img v-if="activeFotoPreview" :src="activeFotoPreview" fluid />
    </b-modal>
    <ModalConfirm
      id="modal-confirm-transfer-kekurangan"
      title="Konfirmasi Transfer Kekurangan"
      :isSubmitting="isSubmittingTransferKekurangan"
      desc="Apakah anda yakin untuk mengunggah bukti transfer kekurangan?"
      @submit="onSubmitTransferKekurangan"
    />
  </div>
</template>

<script>
import FotoPendukung from '@/components/webcam/FotoPendukung'

export default {
  name: 'DisbursementPendingShortfallTransferAction',
  components: {
    FotoPendukung,
  },
  props: {
    disbursementPending: {
      type: Object,
      default: () => ({}),
    },
    refreshDetail: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      buktiTransferKekuranganFoto: this.createUploadFoto(0),
      buktiTransferKekuranganPublicUrl: '',
      activeFotoPreview: '',
      isUploadingTransferKekurangan: false,
      isSubmittingTransferKekurangan: false,
    }
  },
  methods: {
    createUploadFoto(index) {
      return {
        index,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: 'Pilih Foto',
        publicUrl: '',
        fileName: '',
      }
    },
    async onUploadTransferKekurangan(file) {
      if (!file) return

      if (!this.isImageFile(file)) {
        this.resetTransferKekuranganUpload()
        this.$helper.toastErr(this, 'File harus berupa gambar.')
        return
      }

      this.isUploadingTransferKekurangan = true
      this.buktiTransferKekuranganPublicUrl = ''

      this.$store.dispatch('loading/show')
      let response

      try {
        response = await this.$helper.uploadPresigned({
          vue: this,
          path: 'gadai-disburse/create-transfer-url',
          fileUpload: this.$helper.createSafeFileCopy(file),
        })
      } catch (error) {
        this.resetTransferKekuranganUpload()
        this.$helper.parseError(this, error)
        return
      } finally {
        this.isUploadingTransferKekurangan = false
        this.$store.dispatch('loading/hide')
      }

      if (!response.success) {
        this.resetTransferKekuranganUpload()
        this.$helper.toastErr(this, 'Gagal upload bukti transfer. Silakan coba lagi.')
        return
      }

      this.buktiTransferKekuranganPublicUrl = response.publicUrl
    },
    openTransferKekuranganFotoPreview() {
      if (!this.buktiTransferKekuranganFoto.activeFotoPendukungBase64) return

      this.activeFotoPreview = this.buktiTransferKekuranganFoto.activeFotoPendukungBase64
      this.$bvModal.show('modal-preview-foto-transfer-kekurangan')
    },
    openModalConfirmTransferKekurangan() {
      this.$bvModal.show('modal-confirm-transfer-kekurangan')
    },
    async onSubmitTransferKekurangan() {
      const id = this.disbursementPending.id

      if (!id) {
        this.$helper.toastErr(this, 'ID disbursement tidak ditemukan.')
        return
      }

      if (!this.buktiTransferKekuranganPublicUrl) {
        this.$helper.toastErr(this, 'Upload bukti transfer terlebih dahulu.')
        return
      }

      const payload = {
        pathFotoTransfer: [this.buktiTransferKekuranganPublicUrl],
      }

      this.isSubmittingTransferKekurangan = true

      try {
        await this.$axios.post(`gadai-disburse/${id}/upload-transfer`, payload)
        await this.refreshDetail()
        this.$bvModal.hide('modal-confirm-transfer-kekurangan')
        this.$helper.toastSucc(this, 'Bukti transfer kekurangan berhasil dikirim.')
      } catch (error) {
        this.$helper.parseError(this, error)
      } finally {
        this.isSubmittingTransferKekurangan = false
      }
    },
    resetTransferKekuranganUpload() {
      this.buktiTransferKekuranganPublicUrl = ''
      this.buktiTransferKekuranganFoto.fotoBarangPendukung = null
      this.buktiTransferKekuranganFoto.fotoBarangPendukungBase64 = null
      this.buktiTransferKekuranganFoto.activeFotoPendukungBase64 = null
      this.buktiTransferKekuranganFoto.checkFotoBarangPendukung = false
      this.buktiTransferKekuranganFoto.publicUrl = ''
      this.buktiTransferKekuranganFoto.fileName = ''
    },
    isImageFile(file) {
      return file && file.type && file.type.startsWith('image/')
    },
  },
}
</script>

<style scoped>
.action-panel {
  background: #f8f9fa;
  border: 1px solid #e4e7ea;
  border-radius: 4px;
  padding: 16px;
}

.disbursement-upload-wrapper .form-dynamic-wrapper {
  max-width: 100%;
}
</style>
